var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.partner==='UNI' ? 'unilink' : ''},[_c('v-main',[_c('router-view'),_c('session-end-modal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }